// app/frontend/components/EventForm/sections/EventFormButtons.tsx
import { Button, Group } from '@mantine/core';
import { EventFormButtonsProps } from '../types';
import { isEditMode } from '../utils/editEventTransform';

const EventFormButtons: React.FC<EventFormButtonsProps> = ({ form, isLoading, onSubmit, event }) => {
  const isEdit = isEditMode(event);
  const isDraft = event.event_status_id === 3;
  const isRecurring = form.values.is_recurring === 'true';

  // Edit mode with published event - single Update button
  if (isEdit && !isDraft) {
    return (
      <Button mt="xl" size="md" color="#EA580C" fullWidth loading={isLoading} onClick={() => onSubmit('publish')}>
        Update Event
      </Button>
    );
  }

  // Create mode OR Edit mode with draft - two buttons
  return (
    <Group mt="xl">
      <Button variant="outline" size="md" fullWidth color="gray" loading={isLoading} onClick={() => onSubmit('draft')}>
        {isEdit ? 'Save Changes as Draft' : 'Save as Draft'}
      </Button>

      <Button type="button" size="md" fullWidth color="#EA580C" loading={isLoading} onClick={() => onSubmit('publish')}>
        {isRecurring ? 'Submit Recurring Event' : 'Submit Event'}
      </Button>
    </Group>
  );
};

export default EventFormButtons;
